import { useState, useEffect } from 'react';

export const BREAKPOINTS = {
  MOBILE: '(max-width: 1023px)',
  TABLET: '(min-width: 768px) and (max-width: 1024px)',
  DESKTOP: '(min-width: 1024px)',
};

/**
 * Custom hook to check if a media query matches.
 * Replaces MUI's useMediaQuery for the shadcn/Tailwind migration.
 */
function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches;
    }
    return false;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const mediaQuery = window.matchMedia(query);
    const handleChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    // Set initial value
    setMatches(mediaQuery.matches);

    // Listen for changes
    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, [query]);

  return matches;
}

export const useIsMobile = () => useMediaQuery(BREAKPOINTS.MOBILE);
export const useIsTablet = () => useMediaQuery(BREAKPOINTS.TABLET);
export const useIsDesktop = () => useMediaQuery(BREAKPOINTS.DESKTOP);
